export default {
  actionIcon: "StarIcon",
  highlightColor: "warning",
  data: [
    // DASHBOARDS
    {
      index: 0,
      label: "Dashboard",
      url: "/dashboard/",
      labelIcon: "HomeIcon",
      highlightAction: true
    },
    // {
    //   index: 1,
    //   label: "Trends",
    //   url: "/trends",
    //   labelIcon: "BarChart2Icon",
    //   highlightAction: true
    // },
    {
      index: 1,
      label: "Dimming Policy",
      url: "/dimmingPolicy",
      labelIcon: "SunriseIcon",
      highlightAction: true
    },
    {
      index: 2,
      label: "View SmartLinks",
      url: "/modemMapView",
      labelIcon: "MapIcon",
      highlightAction: true
    },
    // UI ELEMENTS
    {
      index: 3,
      label: "Zones",
      url: "/zones",
      labelIcon: "CrosshairIcon",
      highlightAction: false
    },
    {
      index: 4,
      label: "Locations",
      url: "/locations",
      labelIcon: "MapPinIcon",
      highlightAction: false
    },
    {
      index: 5,
      label: "SmartLinks",
      url: "/modems",
      labelIcon: "CpuIcon",
      highlightAction: false
    },
    {
      index: 6,
      label: "User Profile",
      url: "/profile",
      labelIcon: "UserIcon",
      highlightAction: false
    },
    {
      index: 7,
      label: "Master View",
      url: "/masterView",
      labelIcon: "CompassIcon",
      highlightAction: true
    }
    // {
    //   index: 9,
    //   label: "Fault Monitoring",
    //   url: "/monirtoring/faultMonitoring",
    //   labelIcon: "ZapOffIcon",
    //   highlightAction: true
    // },
    // {
    //   index: 10,
    //   label: "Data Monitoring",
    //   url: "/monirtoring/dataMonitoring",
    //   labelIcon: "HardDriveIcon",
    //   highlightAction: false
    // }
  ]
};
